// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3329":"css/app.6690","5463":"css/admin-app.6690"}[chunkId] + ".css";
};